import { render, staticRenderFns } from "./copySlaveCostDialog.vue?vue&type=template&id=23c074e8&scoped=true&"
import script from "./copySlaveCostDialog.vue?vue&type=script&lang=js&"
export * from "./copySlaveCostDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c074e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23c074e8')) {
      api.createRecord('23c074e8', component.options)
    } else {
      api.reload('23c074e8', component.options)
    }
    module.hot.accept("./copySlaveCostDialog.vue?vue&type=template&id=23c074e8&scoped=true&", function () {
      api.rerender('23c074e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/copySlaveCostDialog.vue"
export default component.exports